import { Routes } from '@angular/router';
import { authGuard, unauthGuard } from '@optima-stride-ai/optima-platform';
import { COMMON_APP_CHILD_ROUTES, COMMON_ROUTES } from '@optima-stride-ai/optima-app-framework';
import { ApplicationShellComponent } from './app-shell/app-shell.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: '',
        component: ApplicationShellComponent,
        children: [
        {
            path: 'dashboard',
            loadComponent: () => import('./advance-dashboard/adv-dashboard.component').then(m => m.AdvDashboardComponent),
            canActivate: [authGuard]
        },
        {
            path: 'adv-dashboard',
            loadComponent: () => import('./advance-dashboard/adv-dashboard.component').then(m => m.AdvDashboardComponent),
            canActivate: [authGuard]
        },
        {
            path:'strategy',
            loadComponent: () => import('./strategy/strategy-explorer/strategy-explorer.component').then(m => m.StrategyExplorerComponent),
            canActivate: [authGuard]
        },
        {
            path: 'kpis',
            loadComponent: () => import('./kpi/kpi-explorer/kpi-explorer.component').then(m => m.KpiExplorerComponent),
            canActivate: [authGuard]
        },
        {
            path:'measures',
            loadComponent: () => import('./transaction(Measure)/measure-explorer/measure-explorer.component').then(m => m.MeasureExplorerComponent),
            canActivate: [authGuard]
        },
        {
            path:'explorer',
            loadComponent: () => import('./explorer/explorer.component').then(m => m.ExplorerComponent),
            canActivate: [authGuard]
        },
        {
            path:'checkins',
            loadComponent: () => import('./check-in/check-in-explorer/check-in-explorer.component').then(m => m.CheckInExplorerComponent),
            canActivate: [authGuard]
        },
        // {
        //     path:'settings',
        //     loadComponent: () => import('./settings/settings.component').then(m => m.SettingsComponent),
        //     canActivate: [authGuard]
        // },
        // {
        //     path:'bizEntity-types',
        //     loadComponent: () => import('./biz-entity/biz-entity-type/biz-entity-type.component').then(m => m.BizEntityTypeComponent),
        //     canActivate: [authGuard]
        // },
        ...COMMON_APP_CHILD_ROUTES
        ]
        },
    // {
    //     path: 'login',
    //     loadComponent: () => import('@optima-stride-ai/optima-app-framework').then(m => m.LoginComponent),
    //     canActivate: [unauthGuard]
    // },
    // { path: '**', redirectTo: 'dashboard' }
    ...COMMON_ROUTES
];
